import type { DirectiveBinding } from 'vue'

import { getCurrentLocale } from '@/services/translation/index.ts'

export default {
  mounted: (el: HTMLElement, binding: DirectiveBinding) => {
    if (!el.classList.contains('hyphens-auto')) el.classList.add('hyphens-auto')

    if (!el.getAttribute('lang')) {
      el.setAttribute('lang', binding.arg ?? getCurrentLocale())
    }
  },
}
